<div class="commonPopup">
  <ng-template pTemplate="header"></ng-template>
  <div class="trialCont">
    <!-- Image Section -->
    <div class="img">
      <img src="/assets/images/html/Trial-Expired-2.webp" alt="Trial Expired" />
    </div>

    <!-- Content Section -->

    <div class="textCont">
      <h1>Your 14 Day Free Trial is Over</h1>
      <p>
        <strong>Your free trial has ended</strong> —unlock the full power of social media management
        with the <strong>Pro Plan!</strong> Get advanced tools, seamless collaboration, and
        AI-driven features to save time and maximize results.
      </p>

      <!-- Features List -->
      <ul>
        <li>
          ✅
          <div>
            <strong>Complete Social Media Management</strong>
            <p>Plan, schedule, and organize your content effortlessly in one place.</p>
          </div>
        </li>
        <li>
          🤖
          <div>
            <strong>AI-Powered Tools</strong>
            <p>
              Generate engaging posts using AI-driven prompts, and find the best hashtags to boost
              reach.
            </p>
          </div>
        </li>
        <li>
          📊
          <div>
            <strong>In-Depth Social Media Analytics</strong>
            <p>Track performance across platforms with real-time data to optimize your strategy.</p>
          </div>
        </li>
        <li>
          👥
          <div>
            <strong>Team Collaboration & Approval Workflows</strong>
            <p>
              Work seamlessly with your team—share drafts, leave feedback, and approve posts with
              ease.
            </p>
          </div>
        </li>
      </ul>

      <!-- Buttons Section -->
      <!-- <div class="actionButtons mb-4">
        <div class="workspaceSwitch">
          <label for="workspace">Switch Workspace:</label>
          <p-dropdown
            optionLabel="name"
            styleClass="w-100"
            [options]="workspaces"
            id="workspace"
            placeholder="Select Workspace"
          ></p-dropdown>
        </div>
      </div>-->

      <div class="d-md-flex justify-content-end bottomBtn">
        <p-button
          label="Upgrade to Pro"
          icon="pi pi-arrow-up-right"
          iconPos="right"
          (click)="onGoPremium()"
          routerLink="/plans"
        />
      </div>
    </div>
  </div>
</div>
